
/* injects from baggage-loader */

'use strict';

import DialogAlertController from '../alert/alert.controller';

import { failDialg, successDialg } from './graph-onca.const';

import { filter, clone, isEmpty } from 'lodash';

const initialModel = {
  paper: null,
  metal: null,
  glass: null
}

export default class DialogGraphOncaController extends DialogAlertController{
    constructor($log, $rootScope, Dialog, $timeout) {
        'ngInject';
        super($log, $rootScope);

        this.$log = $log;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        
        this.agent = require('_images/feedback/agent_b.png');

        this.state = {
          step: 0
        };
        
        this.model = clone(initialModel);
        this.errors = clone(initialModel);
    }

    totalValidate($value, key){
      return this.resolve.model[key].length === parseInt($value);
    }

    submit(form){
      let response = clone(initialModel);
      
      if(form.$invalid) return false;

      angular.forEach(this.resolve.model, (attr, key) => {
        response[key] = attr.length !== parseInt(this.model[key]);
      });

      if(response.paper || response.metal || response.glass){
        this.onSubmitFail(response)
      } else{
        this.onSubmitSuccess();
      }
    }
    
    onSubmitSuccess(){
      this.Dialog.showFeedback('label-congratulations', successDialg, 'btn-ok', () => {
        this.$timeout(this.ok.bind(this), 600);
        
        this.$timeout(() => {
          this.Dialog.showQuizOnca(this.model, () => false);
        }, 1200);
      })
    }
    
    onSubmitFail(response){
      this.Dialog.showFeedback('label-opa', failDialg, 'btn-ok', ()=> {
        this.errors = response;
      });
    }
  
    isEmpty(){
      let response = [];
      
      angular.forEach(this.model, attr => {
        response.push( isEmpty(attr) );
      })

      return filter(response, value => value === true ).length ? true : false
    }

    toNextStep(){
      this.state.step += 1;
    }

    isLastSentence(){
      return this.state.step === ( this.resolve.texts.length - 1 )
    }    
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/graph-onca/graph-onca.controller.js